"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _lodash = require("lodash");
var _vuePropertyDecorator = require("vue-property-decorator");
var DetailIncome = /*#__PURE__*/function (_Vue) {
  function DetailIncome() {
    var _this;
    (0, _classCallCheck2.default)(this, DetailIncome);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, DetailIncome, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "dataTable", []);
    (0, _defineProperty2.default)(_this, "name", "");
    return _this;
  }
  (0, _inherits2.default)(DetailIncome, _Vue);
  return (0, _createClass2.default)(DetailIncome, [{
    key: "handleView",
    value: function handleView(data) {
      this.visible = true;
      this.name = data.name;
      this.dataTable = (0, _lodash.orderBy)(data.tours, ["id"], ["desc"]);
    }
  }]);
}(_vuePropertyDecorator.Vue);
DetailIncome = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], DetailIncome);
var _default = exports.default = DetailIncome;